// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__2uQk_","pencil":"IconEdit_pencil__38gdG"};